module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'zneiuhq2',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
